import React, { FC } from 'react';
import { TDividerProps } from './Divider.type';
import { SDivider } from './Divider.style';

export const Divider: FC<TDividerProps> = (props) => {
  return <SDivider {...props} />;
};
